import { MailIndex } from 'modules/Mails/pages';
import { type MailboxType, MailboxTypeSchema } from 'modules/Mails/types/mailbox-type';
import { useLocation } from 'react-router';
import { pipe } from 'remeda';
import { safeParse } from 'zod/v4';

export const MailPage = () => {
  const { pathname } = useLocation();

  const mailboxType: MailboxType = pipe(
    pathname.split('/').at(-1),
    segment => safeParse(MailboxTypeSchema, segment),
    result => (result.success ? result.data : 'inbox'),
  );

  return <MailIndex mailboxType={mailboxType} />;
};
